import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import "../../wepcg/sidebar/css/wepcg_bar.css"
import DOAHelp_hints from "../../wepcg/sidebar/DOAhelp_hints";

class DeadOnArrivalBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Dead On Arrival (DOA)</strong></h1>
            <p>
                This claim type should be used for standard DOA returns. DOA machines should come from a reseller with a valid DOA Period Confirmation Number (DPCN) given by Lenovo call center and attached DOA Service Protocol. Please make sure you submit DPCNs with matching serial numbers and that the serial numbers of the physically returning units are correct. Also, please attach the Lenovo Service Protocol for each item. After you submit the claim we will validate DOA reference and serial number and provide you with a return reference similar to other return claims. If either serial number or DOA reference is not valid, the claim will be rejected.
            </p>
            <p>
                In case of mass DOA request, please use the template to fill in required data and attach it.
            </p>
            <DOAHelp_hints />
        </div>
    }
}

export default DeadOnArrivalBar;